var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProfileActive = function SvgProfileActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "#262525",
    rx: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8C62F0",
    d: "M6 36a3 3 0 0 1 3-3h18a3 3 0 0 1 3 3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18 8C12.5 8 8 12.5 8 18s4.5 10 10 10 10-4.5 10-10S23.5 8 18 8m0 5c1.7 0 3 1.3 3 3s-1.3 3-3 3-3-1.3-3-3 1.3-3 3-3m0 13c-2.2 0-4.3-.9-5.8-2.5 2.2-3.2 6.5-4 9.7-1.8q1.05.75 1.8 1.8C22.3 25.1 20.2 26 18 26"
  })));
};
export default SvgProfileActive;